export default "__VITE_ASSET__BWImY$Iy__"